import { CampaignVoucherDTO, VoucherInvalidReason } from '@app/sales/models/voucher.model';

export class ClaimCampaignVoucherAction {
  static readonly type = '[Api] Claim campaign voucher';
  constructor(public campaignCode: string) {}
}

export class ClaimOrValidateCampaignSuccessAction {
  static readonly type = '[Api] Claim campaign voucher success';
  constructor(public response: CampaignVoucherDTO) {}
}

export class ClaimOrValidateCampaignErrorAction {
  static readonly type = '[Api] Claim campaign voucher error';
  constructor(public invalidReason: VoucherInvalidReason) {}
}

export class ValidateCampaignVoucherAction {
  static readonly type = '[Api] Validate campaign voucher';
  constructor() {}
}

export class ResetCampaignVoucherAction {
  static readonly type = '[Voucher] Reset campaign voucher';
  constructor() {}
}
